module.exports = __webpack_public_path__ + "img/green_circle.68c9db82.svg";